/**
 * Alt text for a post's featured photo.
 *
 * The excerpt used to fill this slot, which described the ARTICLE rather than
 * the picture: useless to a screen reader and actively misleading to Google
 * Images, which reads alt as the subject of the photo. `image_alt` is the
 * dedicated Directus field ("subject + visible ID feature + context"); the
 * title is the fallback because it at least names the subject.
 *
 * The directus_files `description` fallback is deliberately absent: reading it
 * needs a nested `image.description` expansion that turns `blog_posts.image`
 * from a uuid string into an object, which every caller of getCanonicalImageUrl
 * would then have to unwrap. Not worth it while image_alt is being backfilled.
 *
 * Its own module, with no imports, because the blog cards are client components:
 * pulling this out of lib/blog-post-page-utils would drag cheerio and the
 * Directus SDK into the browser bundle.
 */
export function resolveBlogImageAlt(post: {
  image_alt?: string | null
  title: string
}): string {
  return post.image_alt?.trim() || post.title
}
